import * as React from "react";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkFigure, UitkImage } from "uitk-react-experimental-images";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { GlobalConfig } from "stores/wizard/config";
import { useLocalization } from "@shared-ui/localization-context";

export interface CobrandImageProps {
  globalConfig?: GlobalConfig;
}

export const CobrandImage: React.FunctionComponent<CobrandImageProps> = ({ globalConfig }) => {
  const { formatText } = useLocalization();
  const altText = formatText("cobrandImage.altText");
  const { cobrandImageUrl = "" } = globalConfig || {};

  if (!!!cobrandImageUrl) {
    return null;
  }

  return (
    <UitkSpacing padding="two">
      <UitkLayoutGrid>
        <UitkLayoutGridItem>
          <UitkFigure className="all-image-fit-contain" style={{ alignSelf: "center", paddingBottom: "15%" }}>
            <UitkImage alt={altText} src={cobrandImageUrl} />
          </UitkFigure>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </UitkSpacing>
  );
};
